import * as React from 'react';
import { UspGroupItem } from '@grandvisionhq/content';
import { Heading } from '@grandvisionhq/elements';
import { useCartStorage } from '../../hooks/use-cart-storage.js';
import { useCartSummaryActionSlots } from '../../slots/summary-slot/context.js';
import { DiscountDescriptionsContainer } from '../DiscountDescriptions/containers/DiscountDescriptionsContainer.js';
import { VoucherCodesLayout } from '../VoucherCodes/VoucherCodesLayout.js';
import { TotalsContainer } from '../Totals/containers/TotalsContainer.js';
import { NavigationContainer } from './components/navigation/NavigationContainer.js';

const Footer = ({ readOnly , summaryLabel , policyItems , unavailableLineItems  })=>{
    const [{ cartId  }] = useCartStorage();
    const { Slots: SummaryActionSlots  } = useCartSummaryActionSlots();
    return /*#__PURE__*/ React.createElement("div", {
        className: "cart-footer"
    }, policyItems && /*#__PURE__*/ React.createElement("div", {
        className: "usp-group__container mobile-hidden"
    }, policyItems.map((item)=>/*#__PURE__*/ React.createElement(UspGroupItem, {
            item: item,
            key: item.text
        })
    )), !readOnly && /*#__PURE__*/ React.createElement("div", {
        className: "cart-footer__aside"
    }, /*#__PURE__*/ React.createElement(DiscountDescriptionsContainer, null)), /*#__PURE__*/ React.createElement("div", {
        className: "cart-footer__main"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "cart-footer__heading",
        variant: "small"
    }, summaryLabel), !readOnly && SummaryActionSlots.FirstComponent && /*#__PURE__*/ React.createElement(SummaryActionSlots.FirstComponent, {
        cartId: cartId
    }), !readOnly ? SummaryActionSlots.SecondComponent ? /*#__PURE__*/ React.createElement(SummaryActionSlots.SecondComponent, {
        cartId: cartId
    }) : /*#__PURE__*/ React.createElement(VoucherCodesLayout, {
        cartId: cartId
    }) : null, /*#__PURE__*/ React.createElement(TotalsContainer, null)), !readOnly && /*#__PURE__*/ React.createElement("div", {
        className: "cart-footer__navigation"
    }, /*#__PURE__*/ React.createElement(NavigationContainer, {
        unavailableLineItems: unavailableLineItems
    })), policyItems && /*#__PURE__*/ React.createElement("div", {
        className: "usp-group__container desktop-hidden"
    }, policyItems.map((item)=>/*#__PURE__*/ React.createElement(UspGroupItem, {
            item: item,
            key: item.text
        })
    )));
};

export { Footer };
//# sourceMappingURL=Footer.js.map
